var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['btn-external'],attrs:{"href":"/","target":"_blank"}},[_c('span',[_vm._v("Open in new tab")])])}
var staticRenderFns = []

export { render, staticRenderFns }